<script>
import { mapActions, mapGetters } from 'vuex';
import { required, email } from '@vuelidate/validators';

export default {
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
    }),
  },
  validations() {
    return {
      email: { required, email },
    };
  },
  methods: {
    ...mapActions('assistantWizard', ['next', 'updateChannelConfigItem']),
    inputConfigItem(e) {
      this.updateChannelConfigItem({
        channel: 'email',
        item: e.target.name,
        value: e.target.value,
      });
    },
  },
};
</script>

<template>
  <section class="flex items-center flex-col">
    <form
      class="flex flex-col w-full flex-1 mb-8 items-center"
      @submit.prevent="next()"
    >
      <label
        class="text-xl text-center text-slate-900 dark:text-slate-50 mb-8"
        :class="{ error: $v.email.$error }"
        for="email"
      >
        {{ $t('ASSISTANT_MGMT.ADD.EMAIL_CHANNEL.EMAIL.LABEL') }}
      </label>

      <input
        v-model.trim="email"
        type="text"
        name="email"
        class="rounded-md border-2 border-slate-100 text-center p-2 w-80 h-10 leading-10"
        :placeholder="$t('ASSISTANT_MGMT.ADD.EMAIL_CHANNEL.EMAIL.SUBTITLE')"
        @blur="$v.email.$touch"
        @input="inputConfigItem"
      />
    </form>
  </section>
</template>
